export default __webpack_public_path__ + "static/media/OTHER_CULTURE.e8facd3d.svg";